import type { FeedbackMessages } from './en';

const fr: FeedbackMessages = {
  qualified: {
    title: 'Merci d’avoir participé à cette étude !',
    text: 'Vous pouvez maintenant fermer cette fenêtre de navigateur.\n\nNous espérons vous revoir bientôt.',
  },
  quotaFull: {
    title: 'Cette étude est close',
    text: 'Merci de l’intérêt que vous portez à notre étude.\n\nMalheureusement, nous avons déjà reçu toutes les réponses dont nous avions besoin.\n\nNous espérons vous revoir dans une de nos futures études !',
  },
  terminated: {
    title: 'Merci pour votre retour !',
    text: 'Nous espérons vous revoir bientôt lors de nos futures études. En attendant, nous vous souhaitons une excellente journée.\n\nMerci de fermer cette fenêtre de navigateur.',
  },
  mismatch: {
    title: 'Merci de votre intérêt',
    text: 'Malheureusement, vous ne faites pas partie du groupe cible de cette étude spécifique.\n\nVous pouvez fermer cette page.',
  },
  error: {
    title: 'Nous ne sommes pas en mesure de traiter votre demande',
    linkProblemDetailed:
      'Le lien que vous avez suivi présente un problème. Veuillez vérifier que le lien affiché dans la barre d’adresse correspond bien à celui qui vous a été communiqué, puis réessayez.',
    linkProblemGeneric:
      'Le lien que vous avez suivi présente un problème. Veuillez réessayer.',
    contactPerson:
      'Si le problème persiste, veuillez en informer la personne qui vous a communiqué ce lien.',
  },
};

export default fr;
